// @ts-nocheck
// Exact live version restored from the production sourcemap (portal.rebels.io, 2026-10-23).
import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime';
import { Box, Typography } from '@mui/material';
import { yellowMain, black500, black300 } from '../../../constants/color';
import { useState, useRef } from 'react';
import { DownloadAction } from './DownloadAction';
import { uploadContainer } from './style';
import { useDropzone } from 'react-dropzone';
import { palette } from '../../../../theme/palette';
const theme = palette('light');
export const UploadAction = ({ text, h = 173, px = 10, py = 0, onFileUpload, direction = 'col', borderRadius = '25px', variant = 'contained', showMessage = 'no', errorBottom = -10, titleFont = 'default', subtitleFont = 'default', errormsg, singleFile = false, actionHeight = h - 20, 
// Optional: white dropzone with a neutral dashed border (used by hour registration only).
neutral = false }) => {
    const [file, setFile] = useState(null);
    const fileInputRef = useRef(null);
    const onDrop = (acceptedFiles) => {
        if (acceptedFiles.length > 0) {
            const droppedFile = acceptedFiles[0];
            setFile(droppedFile);
            onFileUpload(droppedFile);
        }
    };
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        noClick: true,
        noKeyboard: true
    });
    const handleBrowseClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };
    const clearFile = () => {
        setFile(null);
        onFileUpload(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };
    return _jsxs(Box, {
        position: 'relative',
        height: 'auto',
        children: [
            _jsxs(Box, {
                ...getRootProps(),
                onClick: handleBrowseClick,
                sx: {
                    height: `${h}px`,
                    px: `${px}px`,
                    py: `${py}px`,
                    cursor: 'pointer',
                    borderRadius: borderRadius,
                    background: isDragActive
                        ? theme.primary.lighter
                        : variant === 'outLined'
                            ? ''
                            : neutral
                                ? 'white'
                                : theme.primary.lighter,
                    border: variant === 'outLined' ? '' : `1px dashed ${neutral ? black300 : yellowMain}`,
                    ...uploadContainer
                },
                children: [
                    _jsx('input', { ...getInputProps(), type: 'file', id: 'fileInput', ref: fileInputRef, style: { display: 'none' } }),
                    file === null
                        ? _jsxs(Box, {
                            sx: {
                                ...(direction === 'row'
                                    ? {
                                        display: 'flex',
                                        gap: { xs: 2, md: 17 },
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                    }
                                    : {})
                            },
                            children: [
                                _jsx(Typography, {
                                    fontSize: titleFont === 'default' ? (direction === 'row' ? '14px' : '21px') : titleFont,
                                    fontWeight: 500,
                                    zIndex: 10,
                                    color: black500,
                                    children: text
                                }),
                                _jsxs(Typography, {
                                    zIndex: 10,
                                    fontSize: subtitleFont === 'default' ? '12px' : subtitleFont,
                                    fontWeight: 500,
                                    color: theme.primary.dark,
                                    children: ['Drag & drop file ', singleFile ? '' : '(s)', ' to upload or browse']
                                })
                            ]
                        })
                        : _jsx(Box, {
                            height: direction === 'row' ? h : `${actionHeight}px`,
                            width: '100%',
                            sx: {
                                display: 'flex',
                                alignItems: direction === 'row' ? 'center' : 'end'
                            },
                            onClick: (event) => {
                                event.stopPropagation();
                            },
                            children: _jsx(DownloadAction, {
                                type: 'upload',
                                fileName: file.name,
                                clear: clearFile,
                                width: '100%',
                                fileSize: (file.size / 1024).toFixed(2) + ' KB'
                            })
                        }),
                    showMessage === 'yes' &&
                        file !== null &&
                        _jsx(Box, {
                            sx: {
                                position: 'absolute',
                                top: '50%',
                                left: '0%',
                                textAlign: 'center',
                                width: '100%'
                            },
                            children: _jsx(Typography, { fontSize: '21px', fontWeight: 500, children: 'Complete!' })
                        })
                ]
            }),
            errormsg &&
                _jsx(Box, {
                    sx: { position: 'absolute', bottom: file === null ? -19 : errorBottom, left: 5 },
                    children: _jsx(Typography, { variant: 'caption', fontWeight: 500, color: '#FF0000', children: errormsg })
                })
        ]
    });
};
